import { Provider } from '@angular/core';
import { provideLocationServiceUrl } from '@fashioncloud/location-service-ngx';
import { FcpModalService } from 'fc-ui-components';
import { AppVersionService } from 'services/app-version.service';
import { BrandService } from 'services/brands.service';
import { ScrollService } from 'services/scroll.service';
import { ProductSearchService } from 'services/product-search/product-search.service';
import { UserService } from 'services/user.service';
import { WindowService } from 'services/window.service';
import { FeatureService } from 'services/feature.service';
import { ModalService } from 'services/modal.service';
import { LanguageService } from 'services/language.service';
import { DownloadsService } from 'app/content/services/downloads.service';
import { DownloadContentService } from 'app/content/services/download-content.service';
import { MarketingFilesSearchService } from 'app/content/services/marketing-files-search';
import { ProductService } from 'app/content/services/product.service';
import { MatrixClipboardService } from 'app/b2b-order/services/matrix-clipboard.service';
import { NavigationService } from 'app/b2b-order/services/navigation.service';
import { OrderDraftService } from 'app/b2b-order/services/order-draft';
import { OrderProductDetailService } from 'app/b2b-order/services/order-product-detail/order-product-detail.service';
import { OrderSheetService } from 'app/b2b-order/services/order-sheet/order-sheet.service';
import { OrderService } from 'app/b2b-order/services/order.service';
import { ShoppingCartService } from 'app/b2b-order/services/shopping-cart/shopping-cart.service';
import { StoreSelectorService } from 'src/app/b2b-order/services/store-selector';
import { StoreService } from 'app/b2b-order/services/store.service';
import { LocationStoreService } from 'app/order-management/services/location/locationStore.service';
import { BrandShopService } from 'app/b2b-order/services/brand-shop';
import { BrandShopConfigService } from 'app/b2b-order/services/brand-shop-config';
import { BuyingSelectionService } from 'app/b2b-order/services/buying-selection';
import { OrderHistoryService } from 'app/order-management/services/order-history';
import { ProductsVisibilityService } from 'app/smart-replenishment/services/products-visibility';
import { locationServiceEndpoint } from 'app/order-management/config/sdks/locations-service.config';

export const serviceProviders = [
    provideLocationServiceUrl(locationServiceEndpoint),
    LanguageService,
    UserService,
    FeatureService,
    DownloadsService,
    DownloadContentService,
    WindowService,
    ScrollService,
    NavigationService,
    AppVersionService,
    BrandService,
    ProductService,
    ProductSearchService,
    StoreService,
    LocationStoreService,
    ShoppingCartService,
    StoreSelectorService,
    OrderSheetService,
    OrderProductDetailService,
    MarketingFilesSearchService,
    OrderHistoryService,
    ModalService,
    BuyingSelectionService,
    OrderDraftService,
    MatrixClipboardService,
    BrandShopConfigService,
    BrandShopService,
    ProductsVisibilityService,
    OrderService,
    FcpModalService
] as Provider[];
